import { ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';

// Legacy OTP-info caching has moved to OtpSessionService. The resolver remains
// as a no-op so the route definition keeps working.
export const complianceResolver: ResolveFn<null> = (): Observable<null> => of(null);

export function getValidationErrorKey(err: unknown): string | null {
  const errors = (err as { error?: { errors?: Record<string, unknown> } })?.error
    ?.errors;
  return errors ? Object.keys(errors)[0] ?? null : null;
}
